export const placess = [
  {
    id: 1,
    title: "Aşgabat şäheri",
    content: [
      { name: "Bagtyýarlyk etraby" },
      { name: "Berkararlyk etraby" },
      { name: "Köpetdag etraby" },
      { name: "Büzmeýin etraby" },
    ]
  },
  {
    id: 2,
    title: "Ahal welaýaty",
    content: [
      { name: "Bäherden etraby" },
      { name: "Gökdepe etraby" },
      { name: "Ak bugdaý etraby" },
      { name: "Kaka etraby" },
      { name: "Tejen etraby" },
      { name: "Babadaýhan etraby" },
      { name: "Sarahs etraby" },
    ]
  },
  {
    id: 3,
    title: "Balkan welaýaty",
    content: [
      { name: "Balkanabat şäheri" },
      { name: "Türkmenbaşy şäheri" },
      { name: "Gyzylarbat etraby" },
      { name: "Türkmenbaşy etraby" },
      { name: "Bereket etraby" },
      { name: "Etrek etraby" },
      { name: "Esenguly etraby" },
      { name: "Magtymguly etraby" },
    ]
  },
  {
    id: 4,
    title: "Daşoguz welaýaty",
    content: [
      { name: "Daşoguz şäheri" },
      { name: "Şabat etraby" },
      { name: "Görogly etraby" },
      { name: "Akdepe etraby" },
      { name: "Boldumsaz etraby" },
      { name: "Köneürgenç etraby" },
      { name: "Saparmyrat Türkmenbaşy etraby" },
      { name: "Ruhubelent etraby" },

    ]
  },
  {
    id: 5,
    title: "Lebap welaýaty",
    content: [
      { name: "Türkmenabat şäheri" },
      { name: "Çärjew etraby" },
      { name: "Dänew etraby" },
      { name: "Darganata etraby" },
      { name: "Saýat etraby" },
      { name: "Halaç etraby" },
      { name: "Kerki etraby" },
      { name: "Hojambaz etraby" },
      { name: "Köýtendag etraby" },
    ]
  },
  {
    id: 6,
    title: "Mary welaýaty",
    content: [
      { name: "Mary şäheri" },
      { name: "Baýramaly şäheri" },
      { name: "Mary etraby" },
      { name: "Baýramaly etraby" },
      { name: "Wekilbazar etraby" },
      { name: "Türkmengala etraby" },
      { name: "Garagum etraby" },
      { name: "Sakarçäge etraby" },
      { name: "Murgap etraby" },
      { name: "Ýolöten etraby" },
      { name: "Tagtabazar etraby" },
    ]
  }
]

export const office = [
  { id: 1, name: 'Türkmenistanyň Ýokary kazyýeti' },
  { id: 2, name: 'Arkadag şäher kazyýeti' },
  { id: 3, name: "Kärizek etrap kazyýeti" },
  { id: 4, name: "Gorjaw etrap kazyýeti" },
  { id: 5, name: "Aşgabat şäher kazyýeti" },
  { id: 6, name: "Bagtyýarlyk etrap kazyýeti" },
  { id: 7, name: "Berkararlyk etrap kazyýeti" },
  { id: 8, name: "Köpetdag etrap kazyýeti" },
  { id: 9, name: "Büzmeýin etrap kazyýeti" },
  { id: 10, name: "Ahal welaýat kazyýeti" },
  { id: 11, name: "Bäherden etrap kazyýeti" },
  { id: 12, name: "Gökdepe etrap kazyýeti" },
  { id: 13, name: "Ak bugdaý etrap kazyýeti" },
  { id: 14, name: "Kaka etrap kazyýeti" },
  { id: 15, name: "Tejen etrap kazyýeti" },
  { id: 16, name: "Babadaýhan etrap kazyýeti" },
  { id: 17, name: "Sarahs etrap kazyýeti" },
  { id: 18, name: "Balkan welaýat kazyýeti" },
  { id: 19, name: "Balkanabat şäher kazyýeti" },
  { id: 20, name: "Türkmenbaşy şäher kazyýeti" },
  { id: 21, name: "Gyzylarbat etrap kazyýeti" },
  { id: 22, name: "Türkmenbaşy etrap kazyýeti" },
  { id: 23, name: "Bereket etrap kazyýeti" },
  { id: 24, name: "Etrek etrap kazyýeti" },
  { id: 25, name: "Esenguly etrap kazyýeti" },
  { id: 26, name: "Magtymguly etrap kazyýeti" },
  { id: 27, name: "Daşoguz welaýat kazyýeti" },
  { id: 28, name: "Daşoguz şäher kazyýeti" },
  { id: 29, name: "Şabat etrap kazyýeti" },
  { id: 30, name: "Görogly etrap kazyýeti" },
  { id: 31, name: "Akdepe etrap kazyýeti" },
  { id: 32, name: "Boldumsaz etrap kazyýeti" },
  { id: 33, name: "Köneürgenç etrap kazyýeti" },
  { id: 34, name: "Saparmyrat Türkmenbaşy etrap kazyýeti" },
  { id: 35, name: "Ruhubelent etrap kazyýeti" },
  { id: 36, name: "Lebap welaýat kazyýeti" },
  { id: 37, name: "Türkmenabat şäher kazyýeti" },
  { id: 38, name: "Çärjew etrap kazyýeti" },
  { id: 39, name: "Dänew etrap kazyýeti" },
  { id: 40, name: "Darganata etrap kazyýeti" },
  { id: 41, name: "Saýat etrap kazyýeti" },
  { id: 42, name: "Halaç etrap kazyýeti" },
  { id: 43, name: "Kerki etrap kazyýeti" },
  { id: 44, name: "Hojambaz etrap kazyýeti" },
  { id: 45, name: "Köýtendag etrap kazyýeti" },
  { id: 46, name: "Mary welaýat kazyýeti" },
  { id: 47, name: "Mary şäher kazyýeti" },
  { id: 48, name: "Baýramaly şäher kazyýeti" },
  { id: 49, name: "Mary etrap kazyýeti" },
  { id: 50, name: "Baýramaly etrap kazyýeti" },
  { id: 51, name: "Wekilbazar etrap kazyýeti" },
  { id: 52, name: "Türkmengala etrap kazyýeti" },
  { id: 53, name: "Garagum etrap kazyýeti" },
  { id: 54, name: "Sakarçäge etrap kazyýeti" },
  { id: 55, name: "Murgap etrap kazyýeti" },
  { id: 56, name: "Ýolöten etrap kazyýeti" },
  { id: 57, name: "Tagtabazar etrap kazyýeti" },
]

export const auctionLocation = [
  { id: 1, title: 'Aşgabat şäheri' },
  { id: 2, title: 'Arkadag şäheri' },
  { id: 3, title: 'Ahal welaýaty' },
  { id: 4, title: 'Balkan welaýaty' },
  { id: 5, title: 'Daşoguz welaýaty' },
  { id: 6, title: 'Lebap welaýaty' },
  { id: 7, title: 'Mary welaýaty' },
]

export const appeal = [
  { id: 1, name: 'Arza nägilelik (ýakyn wagtda)' },
  { id: 2, name: 'Hak isleýiş arza (ýakyn wagtda)' }
]

export const act = [
  { id: 1, name: 'Höküm' },
  { id: 2, name: 'Çözgüt' },
  { id: 3, name: 'Kesgitnama' }
]


export const lawHelp = [
  {
    id: 1,
    title: "Türkmenistanyň Ýokary kazyýeti",
    content: [
      {
        name: "Türkmenistanyň ýokary kazyýetiniň başlygy",
        day: 'Penşenbe',
        time: '10:00-13:00'
      },
      {
        name: "Türkmenistanyň ýokary kazyýetiniň başlygyň orunbasary",
        day: 'Çarşenbe',
        time: '10:00-13:00'
      },
      {
        name: "Türkmenistanyň ýokary kazyýetiniň başlygyň orunbasary",
        day: 'Sişenbe',
        time: '10:00-13:00'
      },
      {
        name: "Türkmenistanyň ýokary kazyýetiniň başlygyň orunbasary",
        day: 'Duşenbe',
        time: '10:00-13:00'
      },
    ],
    address: [
      {
        address: 'Aşgabat şäheri 2022-nji köçesiniň 86-njy jaýy',
        time: '10:00 - 13:00',
        phone: '+993 12 39-09-32'
      }
    ]
  },
  {
    id: 2,
    title: "Arkadag şäher kazyýeti",
    content: [
      {
        name: "Arkadag şäher kazyýetiniň başlygy",
        day: 'Çarşenbe, Anna',
        time: '10:00-13:00'
      },
      {
        name: "Arkadag şäher kazyýetiniň başlygynyň orunbasary",
        day: 'Duşenbe, Penşenbe',
        time: '10:00-13:00'
      },
    ],
    address: [
      {
        address: 'Arkadag şäheri, Maýa Kulyýewa 5',
        time: '10:00 - 13:00',
        phone: '+993 12 33-03-54'
      }
    ]
  },
  {
    id: 2,
    title: "Arbitraž kazyýeti",
    content: [
      {
        name: "Arbitraž kazyýetiniň başlygy",
        day: 'Penşenbe',
        time: '15:00-18:00'
      },
    ],
    address: [
      {
        address: 'Aşgabat şäheri 2022-nji köçesiniň 86-njy jaýy',
        time: '15:00 - 18:00',
        phone: '+993 12 39-09-32'
      }
    ]
  },
  {
    id: 2,
    title: "Ahal welaýat kazyýeti",
    content: [
      {
        name: "Ahal welaýat kazyýetiniň başlygy",
        day: 'Çarşenbe',
        time: '10:00-12:00'
      },
      {
        name: "Ahal welaýat kazyýetiniň başlygyň orunbasary",
        day: 'Duşenbe',
        time: '10:00-12:00'
      },
      {
        name: "Ahal welaýat kazyýetiniň başlygyň orunbasary",
        day: 'Anna',
        time: '10:00-12:00'
      },
      {
        name: "Nobatçy kazy",
        day: 'Günüň dowamynda',
      },
    ],
    address: [
      {
        address: 'Ahal welaýat, Ak bugdaý etrap,Änew şäheri, Ahal köçesi, jaý №1',
        time: '10:00 - 12:00',
        phone: '+993 13 73-32-47'
      }
    ]
  },
  {
    id: 3,
    title: "Balkan welaýat kazyýeti",
    content: [
      {
        name: "Balkan welaýat kazyýetiniň başlygy",
        day: 'Çarşenbe',
        time: '10:00-13:00'
      },
    ],
    address: [
      {
        address: 'Balkan welaýatynyň Balkanabat şäheriniň, Gurtgeldi Annaýew köçesi 160 ýaşaýyş jaý toplumy',
        time: '10:00 - 13:00',
        phone: '+993 22 26-05-24'
      }
    ]
  },
  {
    id: 4,
    title: "Daşoguz welaýat kazyýeti",
    content: [
      {
        name: "Daşoguz welaýat kazyýetiniň başlygy",
        day: 'Penşenbe',
        time: '10:00-16:00'
      },
      {
        name: "Daşoguz welaýat kazyýetiniň başlygyň orunbasary",
        day: 'Duşenbe',
        time: '10:00-17:00'
      },
      {
        name: "Daşoguz welaýat kazyýetiniň başlygyň orunbasary",
        day: 'Çarşenbe',
        time: '10:00-17:00'
      },
    ],
    address: [
      {
        address: 'Daşoguz şäheri, Garaşsyzlygyň 10 ýyllygy köçesi, 3/1-nji jaýy',
        time: '10:00 - 16:00',
        phone: '+993 12 38-08-88'
      }
    ]
  },
  {
    id: 5,
    title: "Lebap welaýat kazyýeti",
    content: [
      {
        name: "Lebap welaýat kazyýetiniň başlygy",
        day: 'Penşenbe, Sişenbe',
        time: '10:00-12:00'
      },
    ],
    address: [
      {
        address: 'Türkmenabat şäheri, Magtymguly köç., 82 "a"',
        time: '10:00 - 12:00',
        phone: '+993 12 03-92-00'
      }
    ]
  },
  {
    id: 6,
    title: "Mary welaýat kazyýeti",
    content: [
      {
        name: "Mary welaýat kazyýetiniň başlygy",
        day: 'Penşenbe',
        time: '10:00-13:00'
      },
      {
        name: "Mary welaýat kazyýetiniň başlygyň orunbasary",
        day: 'Duşenbe',
        time: '10:00-13:00'
      },
    ],
    address: [
      {
        address: 'Mary welaýaty, Mary şäheri, S.Nyýazow köçesiniň 1”a” jaýy',
        time: '10:00 - 13:00',
        phone: '+993 52 26-05-56'
      }
    ]
  }
]

